import { z } from 'zod'

// Mirrors the BE's `LinkedDocumentMetadata` shape. Used directly for the case-citations and
// related-cases responses; extended in `case-review-schema.ts` with review fields for the
// citing-cases response.
export const CitationMetadataSchema = z.object({
  name: z.string().describe('The name of the document.'),
  document_type: z.string().describe("The type of document: either 'law' or 'caselaw'."),
  citation: z.string().optional().nullable().describe('The citation string for the document (optional).'),
  bb_citation: z.string().optional().nullable().describe('The Bluebook citation string for the document (optional).'),
  parent_id: z.string().optional().nullable().describe('The ID of the parent document (optional).'),
  jurisdiction: z.string().optional().nullable().describe('The jurisdiction of the document (optional).'),
  text: z.string().optional().nullable().describe('The text content of the document (optional).'),
  s3_path: z.string().describe('The S3 storage path of the document.'),
})
export type CitationMetadata = z.infer<typeof CitationMetadataSchema>

export const CitatorCasesResponseSchema = z.array(CitationMetadataSchema)
export type CitatorCasesResponse = z.infer<typeof CitatorCasesResponseSchema>
